import { getNorvoBrandCopy } from '../../lib/norvo-brand'
import { normalizeLanguageCode } from '../../lib/i18n'

type NorvoAttributionProps = {
  lang?: string
  variant?: 'footer' | 'inline' | 'block'
  className?: string
}

export function NorvoAttribution({ lang, variant = 'footer', className = '' }: NorvoAttributionProps) {
  const copy = getNorvoBrandCopy(normalizeLanguageCode(lang || 'EN'))
  const rootClass = ['bbg-norvo-attribution', `bbg-norvo-attribution--${variant}`, className].filter(Boolean).join(' ')

  if (variant === 'inline') {
    return <span className={rootClass}>{copy.inline}</span>
  }

  if (variant === 'block') {
    return (
      <div className={rootClass}>
        <p className="bbg-norvo-attribution__title">{copy.blockTitle}</p>
        <p className="bbg-norvo-attribution__body">{copy.blockBody}</p>
      </div>
    )
  }

  return <span className={rootClass}>{copy.footerCopyright}</span>
}
